const API_URL =
  window.location.hostname === "localhost"
    ? "http://localhost:5000"
    : "https://citas.dsm.edu.ni";

export default API_URL;